import { Eye, ArrowLeft } from "lucide-react";
import { TOTAL_COUNTRIES } from "@/lib/geo";
import { ShareDialog } from "./ShareDialog";
import { ViewCounter } from "./ViewCounter";
import { UserMenu } from "./auth/UserMenu";
import { FollowButton } from "./friends/FollowButton";
import { NotificationBell } from "./friends/NotificationBell";

const Stat = ({ label, value, testId, color }) => (
  <div className="hidden xl:block whitespace-nowrap">
    <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500">{label}</p>
    <p className={`font-display text-sm font-semibold ${color}`} data-testid={testId}>{value}</p>
  </div>
);

export const Header = ({ data, readOnly, friendView }) => {
  const v = data?.visited || [];
  const goals = data?.goals || [];
  const cities = v.reduce((s, x) => s + x.cities.length, 0);
  const pct = Math.round((v.length / TOTAL_COUNTRIES) * 100);
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass-bar" data-testid="app-header">
      <div className="flex items-center justify-between gap-2 sm:gap-6 px-3 sm:px-8 lg:px-12 h-16">
        <a href="#top" className="font-display font-bold tracking-tight text-base sm:text-lg whitespace-nowrap shrink-0" data-testid="brand-logo">
          the bucketlist<span className="text-emerald-400">.</span>
        </a>
        <div className="flex items-center gap-2 sm:gap-8 min-w-0">
          <Stat label="Countries" value={`${v.length} / ${TOTAL_COUNTRIES} · ${pct}%`} testId="stats-countries-visited-count" color="text-emerald-300" />
          <Stat label="Cities" value={cities} testId="stats-cities-count" color="text-emerald-300" />
          <Stat label="Next up" value={data?.wishlist[0]?.country || "—"} testId="stats-next-destination" color="text-amber-300" />
          <Stat label="Life goals" value={`${goals.filter((g) => g.done).length} / ${goals.length}`} testId="stats-life-goals" color="text-rose-300" />
          <nav className={`${readOnly ? "hidden sm:flex" : "hidden lg:flex"} items-center gap-1 text-sm`}>
            <a href="#travel" className="px-3 py-1.5 rounded-full hover:bg-white/10 transition-colors whitespace-nowrap" data-testid="nav-tab-map">World</a>
            <a href="#life" className="px-3 py-1.5 rounded-full hover:bg-white/10 transition-colors whitespace-nowrap" data-testid="nav-tab-life-bucketlist">Before I die</a>
            {!readOnly && <a href="#friends" className="px-3 py-1.5 rounded-full hover:bg-white/10 transition-colors whitespace-nowrap" data-testid="nav-tab-friends">Friends</a>}
          </nav>
          {readOnly ? (
            <>
              <span className="flex items-center gap-1.5 px-3 py-1 rounded-full border border-white/15 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-300" data-testid="read-only-badge"><Eye size={12} /> {data?.owner ? `${data.owner.name.split(" ")[0]}'s${friendView ? " · friend" : " · view only"}` : "View only"}</span>
              {friendView ? (
                <a href="/#friends" className="flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full border border-white/15 hover:bg-white/10 transition-colors" data-testid="friend-page-back"><ArrowLeft size={14} /> My bucket list</a>
              ) : <FollowButton />}
            </>
          ) : (
            <>
              <NotificationBell />
              <ViewCounter />
              <ShareDialog />
              <UserMenu />
            </>
          )}
        </div>
      </div>
    </header>
  );
};
